import React, { useState } from "react";
import '../App.css';
import './contact.css';

function Contact() {
    const [formData, setFormData] = useState({
        topic: '',
        firstName: '',
        lastName: '',
        company: '',
        email: '',
        phone: '',
        message: ''
    });

    const [submitted, setSubmitted] = useState(false);

    // Get API base URL from environment variable
    const apiBaseUrl = process.env.REACT_APP_RAILWAY_URL || 'http://localhost:8000';

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch(`${apiBaseUrl}/api/contact/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData)
            });

            const data = await response.json();

            if (response.ok) {
                // Success
                setSubmitted(true);
                
                // Reset form after 5 seconds
                setTimeout(() => {
                    setFormData({
                        topic: '',
                        firstName: '',
                        lastName: '',
                        company: '',
                        email: '',
                        phone: '',
                        message: ''
                    });
                    setSubmitted(false);
                }, 5000);
            } else {
                console.error('Error sending contact form:', data.error);
                // Just log the error, don't show it to user to keep original behavior
            }

        } catch (error) {
            console.error('Error sending contact form:', error);
            // Just log the error, don't show it to user to keep original behavior
        }
    };

    return (
        <div className="contact-container">
            <h1 className="contact-title">Contact Us</h1>
            <p className="contact-subtitle">Have questions or want to discuss a project together? </p>
            <p className="contact-subtitle">We respond quickly to your questions & are happy to schedule a meeting to discuss more</p>

            <div className="contact-content">
                {submitted ? (
                    <div className="success-message">
                        <i className="fas fa-check-circle"></i>
                        <h2>Thank you for contacting us!</h2>
                        <p>We've received your message and will get back to you shortly.</p>
                    </div>
                ) : (
                    <form className="contact-form" onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label htmlFor="topic">Topic <span className="required">*</span></label>
                            <input
                                type="text"
                                id="topic"
                                name="topic"
                                value={formData.topic}
                                onChange={handleChange}
                                placeholder="Become a customer"
                                required
                            />
                        </div>
                        
                        <div className="form-row">
                            <div className="form-group">
                                <label htmlFor="firstName">First name <span className="required">*</span></label>
                                <input
                                    type="text"
                                    id="firstName"
                                    name="firstName"
                                    value={formData.firstName}
                                    onChange={handleChange}
                                    placeholder="First Name"
                                    required
                                />
                            </div>
                            
                            <div className="form-group">
                                <label htmlFor="lastName">Last name <span className="required">*</span></label>
                                <input
                                    type="text"
                                    id="lastName"
                                    name="lastName"
                                    value={formData.lastName}
                                    onChange={handleChange}
                                    placeholder="Last Name"
                                    required
                                />
                            </div>
                        </div>
                        
                        <div className="form-group">
                            <label htmlFor="company">Company <span className="required">*</span></label>
                            <input
                                type="text"
                                id="company"
                                name="company"
                                value={formData.company}
                                onChange={handleChange}
                                placeholder="Your company"
                                required
                            />
                        </div>
                        
                        <div className="form-group">
                            <label htmlFor="email">Email <span className="required">*</span></label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="you@work.com"
                                required
                            />
                        </div>
                        
                        <div className="form-group">
                            <label htmlFor="phone">Phone number</label>
                            <input
                                type="tel"
                                id="phone"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                placeholder="+46 000 000 000"
                            />
                        </div>
                        
                        <div className="form-group">
                            <label htmlFor="message">Message</label>
                            <textarea
                                id="message"
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                placeholder="Type here"
                                rows="5"
                            ></textarea>
                        </div>
                        
                        <div className="form-footer">
                            
                            <button type="submit" className="submit-button">
                                Submit
                            </button>
                        </div>
                    </form>
                )}
                
                {/*<div className="contact-info">
                    <div className="info-item">
                        <i className="fas fa-envelope"></i>
                        <div>
                            <h3>Email Us</h3>
                            <p>support@penny-app.com</p>
                        </div>
                    </div>
                    
                    <div className="info-item">
                        <i className="fas fa-phone-alt"></i>
                        <div>
                            <h3>Call Us</h3>
                            <p>+46 123 456 789</p>
                        </div>
                    </div>
                    
                    <div className="info-item">
                        <i className="fas fa-map-marker-alt"></i>
                        <div>
                            <h3>Visit Us</h3>
                            <p>Penny HQ, Stockholm, Sweden</p>
                        </div>
                    </div>
                </div>*/}
            </div>
        </div>
    );
}

export default Contact;


